export const WORKSPACE_REWARD_THRESHOLDS_QUERY_KEY = ["workspace-reward-thresholds"] as const;
